import { ToggleGroup, ToggleGroupItem } from 'src/components/ui/toggle-group';
import { clsx } from 'clsx';
import { Controller, useForm } from 'react-hook-form';
import React, { useEffect, useState } from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import { object } from 'yup';
import { emailScheme } from 'src/utils/validation-schemes';
import { Skeleton } from 'src/components/ui/skeleton';
import { useGetAccountsQuery, useUpdateAccountsMutation } from 'src/services/accountsService';
import { useLoader } from 'src/provider/LoaderProvider';
import { PATH_HOME } from 'src/constants/spa-routes';

export const VersionToggleGroup = () => {
  const [initialized, setInitialized] = useState(false);
  const loader = useLoader();
  const { data: account } = useGetAccountsQuery(undefined, { skip: !initialized });
  const [updateAccountInfo, { isSuccess: isSuccessUpdateAccount }] = useUpdateAccountsMutation();
  const { handleSubmit, watch, control, resetField } = useForm({
    defaultValues: {
      version: '',
    },
    resolver: yupResolver(
      object({
        version: emailScheme({ required: true }).label('Version'),
      }),
    ),
  });

  useEffect(() => {
    if (isSuccessUpdateAccount) {
      loader.show();
      setTimeout(() => {
        window.location.assign(PATH_HOME.ROOT);
      }, 2000);
    }
  }, [isSuccessUpdateAccount]);

  useEffect(() => {
    setTimeout(() => {
      setInitialized(true);
    }, 2000);
  }, []);

  useEffect(() => {
    if (account) {
      const version = localStorage.getItem('API_VERSION');

      resetField('version', { defaultValue: version || account.version });
    }
  }, [account]);

  const submit = (data) => {
    loader.show();
    localStorage.setItem('API_VERSION', data.version);

    if (account.version_v2_setup) {
      window.location.assign(PATH_HOME.ROOT);
      return;
    }

    updateAccountInfo({ version_v2_setup: true });
  };

  return initialized ? (
    <form onSubmit={handleSubmit(submit)} className={'flex flew-row w-32 max-h-[34px]'}>
      <Controller
        control={control}
        name="version"
        render={({ field: { onChange, value }, fieldState: { error } }) => (
          <ToggleGroup
            className={clsx('flex gap-1.5 justify-items-stretch items-stretch w-full')}
            onChange={onChange}
            onValueChange={(value) => {
              if (value) {
                onChange(value);
                submit({ version: value });
              }
            }}
            defaultValue={value}
            value={value}
            type="single"
          >
            <ToggleGroupItem
              className={
                'flex flex-1 items-center justify-center lowercase [&[data-state=on]]:bg-ebony [&[data-state=on]]:text-white [&[data-state=on]]:font-semibold hover:border-ebony'
              }
              key={'v1'}
              value={'v1'}
            >
              v1
            </ToggleGroupItem>
            <ToggleGroupItem
              className={
                'flex flex-1 items-center justify-center lowercase [&[data-state=on]]:bg-ebony [&[data-state=on]]:text-white [&[data-state=on]]:font-semibold hover:border-ebony'
              }
              key={'v2'}
              value={'v2'}
            >
              v2
            </ToggleGroupItem>
          </ToggleGroup>
        )}
      />
    </form>
  ) : (
    <div className={'flex flew-row gap-1.5 w-32 h-[34px]'}>
      <Skeleton className={'h-full w-full'}></Skeleton>
      <Skeleton className={'h-full w-full'}></Skeleton>
    </div>
  );
};
